import { toast } from 'sonner';
import { FileText, FileDown, Printer } from 'lucide-react';
import { Card, mono, GREEN } from '../bfsi/bfsiShared';
import { openPdf, downloadFile, fmtDate } from './qrApi';

const Link = ({ onClick, children, testId }) => (
  <button data-testid={testId} onClick={onClick} className="inline-flex items-center gap-1 text-xs hover:underline" style={{ color: GREEN }}>{children}</button>
);

export function PassportBatchesTable({ batches, onSelect, selectedId, tenantScoped = false }) {
  const guard = (fn) => () => fn().catch(e => toast.error(e.message));
  return (
    <Card data-testid="qr-batches-table" className="p-0 overflow-hidden">
      <table className="w-full text-sm">
        <thead style={{ background: '#FAF9F6', color: '#6b7069' }}>
          <tr className="text-left">
            <th className="px-4 py-2 font-medium">Book</th>
            {!tenantScoped && <th className="px-4 py-2 font-medium">Customer</th>}
            <th className="px-4 py-2 font-medium">Issued</th>
            <th className="px-4 py-2 font-medium">Structure</th>
            <th className="px-4 py-2 font-medium">Profile</th>
            <th className="px-4 py-2 font-medium">In stock</th>
            <th className="px-4 py-2 font-medium" title="Passports scanned at least once (uptake vs issuance)">Scanned ≥ 1</th>
            <th className="px-4 py-2 font-medium">Downloads</th>
          </tr>
        </thead>
        <tbody>
          {batches.length === 0 && <tr><td colSpan={8} className="px-4 py-6 text-center" style={{ color: '#9a9e96' }}>No batches yet</td></tr>}
          {batches.map(b => (
            <tr key={b.id} data-testid={`qr-batch-${b.id}`} className="border-t cursor-pointer hover:bg-[#FAF9F6]"
              style={{ borderColor: '#F3F1EA', background: selectedId === b.id ? '#E7F2EE' : undefined }} onClick={() => onSelect?.(b.id)}>
              <td className="px-4 py-2" style={mono} data-testid={`qr-batch-book-${b.id}`}>{b.book_no || '—'}</td>
              {!tenantScoped && <td className="px-4 py-2">{b.tenant_name}</td>}
              <td className="px-4 py-2"><span style={mono}>{b.count}</span>{b.parents ? <span className="text-xs" style={{ color: '#6b7069' }}> + {b.parents} parents</span> : null}<div className="text-xs" style={{ color: '#9a9e96' }}>{fmtDate(b.created_at)}</div></td>
              <td className="px-4 py-2">{b.children_per_parent ? `${b.parents} cartons × ${b.children_per_parent}` : 'flat'}</td>
              <td className="px-4 py-2">{b.profile_name || '—'}</td>
              <td className="px-4 py-2"><span style={mono}>{b.issued_count}</span> ISSUED</td>
              <td className="px-4 py-2" data-testid={`qr-batch-scanned-${b.id}`}>
                <span style={mono}>{b.scanned_count}</span>
                <span className="text-xs ml-1" style={{ color: '#9a9e96' }}>/ {(b.count || 0) + (b.parents || 0)}</span>
              </td>
              <td className="px-4 py-2" onClick={e => e.stopPropagation()}>
                <div className="flex flex-wrap gap-x-3 gap-y-1">
                  {!tenantScoped && <Link testId={`qr-batch-csv-${b.id}`} onClick={guard(() => downloadFile(`/passport-batches/${b.id}/passports.csv`, `passports-${b.id}.csv`))}><FileText size={12} /> CSV</Link>}
                  <Link testId={`qr-batch-pdf-std-${b.id}`} onClick={guard(() => openPdf(`/passport-batches/${b.id}/labels.pdf?size=standard`))}><Printer size={12} /> PDF 25×15</Link>
                  <Link testId={`qr-batch-pdf-micro-${b.id}`} onClick={guard(() => openPdf(`/passport-batches/${b.id}/labels.pdf?size=micro`))}><Printer size={12} /> PDF 20×10</Link>
                  <Link testId={`qr-batch-zpl-std-${b.id}`} onClick={guard(() => downloadFile(`/passport-batches/${b.id}/labels.zpl?size=standard`, `labels-standard-${b.id}.zpl`))}><FileDown size={12} /> ZPL 25×15</Link>
                  <Link testId={`qr-batch-zpl-micro-${b.id}`} onClick={guard(() => downloadFile(`/passport-batches/${b.id}/labels.zpl?size=micro`, `labels-micro-${b.id}.zpl`))}><FileDown size={12} /> ZPL 20×10</Link>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Card>
  );
}
